type SearchableProject = {
  id: number;
  name: string;
  isFolder?: boolean;
  is_folder?: boolean;
  parentId?: number | null;
  parent_id?: number | null;
};

/** Search the already-authorized full project list, including chats in closed folders. */
export function searchSidebarProjects<T extends SearchableProject>(roots: T[], projects: T[], query: string) {
  const normalized = query.trim().toLocaleLowerCase();
  const folders: T[] = [];
  const tasks: { task: T; parent?: T }[] = [];
  if (!normalized) return { folders, tasks };
  const records = new Map([...roots, ...projects].map(project => [project.id, project]));
  const matches = (name: string) => name.toLocaleLowerCase().includes(normalized);
  for (const project of Array.from(records.values())) {
    if (project.isFolder || project.is_folder) {
      if (matches(project.name)) folders.push(project);
    } else {
      const parent = records.get(project.parentId ?? project.parent_id ?? -1);
      if (matches(project.name) || (parent && matches(parent.name))) tasks.push({ task: project, parent });
    }
  }
  return { folders, tasks };
}
